import { baseScopesRequiredPerField } from '../fields-scopes';

export type NumberValue = number | null;

export const validateNumberValue = (value: unknown): value is NumberValue =>
	value === null || typeof value === 'number';

export const numberScopes = baseScopesRequiredPerField;
